/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-10-12",
    versionChannel: "nightly",
    buildDate: "2023-10-12T00:20:36.060Z",
    commitHash: "2422793d1be3929e7b4e0fd0bf47bd1bcc7c0126",
};
